import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useRequiredFields from "../../../../hooks/useRequiredFields";
import Http from "../../../Common/Http";
import ReactDropdown from "../../../Common/ReactDropdown";
import Select from "react-select";

const EditLeaveRules = () => {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({});
  const { id } = useParams();
  const { checkRequiredFields } = useRequiredFields();
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await Http.get(`/weekly-off-day/${id}/edit`);
      setInputs({
        year: res.data.year,
        day: res.data.day,
      });
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // to handle input changes
  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const formSubmit = () => {
    if (checkRequiredFields()) {
      Http.put("/weekly-off-day/" + id, inputs).then((res) => {
        navigate("/weekly-off-day", {
          state: { message: res.data.message, type: res.data.type },
        });
      });
    }
  };
  const reactDropdownHandler = (field, prop) => (e) => {
    setInputs((values) => ({
      ...values,
      [field]: prop ? e.value[prop] : e.value,
    }));
  };

  const findSelectedOption = (options, value, key) => {
    return options.find((item) => item[key] === value);
  };

  const day = [
    { value: "1", label: "Saturday" },
    { value: "2", label: "Sunday" },
    { value: "3", label: "Monday" },
    { value: "4", label: "Tuesday" },
    { value: "5", label: "Wednesday" },
    { value: "6", label: "Thursday" },
    { value: "7", label: "Friday" },
  ];

  return (
    <div>
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Edit Weekly Off Day</h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <h6 className="card-body-title mg-sm-b-30">Edit Weekly Off Day</h6>

            {loading ? (
              <ProgressSpinner />
            ) : (
              <>
                <div className="row">
                  <div className="col-lg">
                    <label className="font-weight-bold">
                      Year <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Year"
                      name="year"
                      value={inputs.year || ""}
                      onChange={handleChange}
                      data-required
                    />
                  </div>
                  <div className="col-lg">
                    <label className="font-weight-bold">Day</label>
                    <div className="select">
                      <Select
                        className="basic-single"
                        classNamePrefix="select"
                        defaultValue={day[0]}
                        name="day"
                        options={day}
                        onChange={(selectedOption) => {
                          setInputs((values) => ({
                            ...values,
                            day: selectedOption.value
                          }));
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-3">
                    <button className="btn btn-primary btn-block mg-b-10" onClick={formSubmit}>
                      <i className="fa fa-send mg-r-10"></i> Update
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
          {/* card */}
        </div>
      </div>
    </div>
  );
};

export default EditLeaveRules;
